export const MODULE_IMPORTANCE = {
    // The strategy itself. Everything else is context for a retracement call,
    // so this is set well clear of the rest rather than one notch above.
    fibonacci: 10,
    points: 3,
    knots: 2,
    // Placed alongside knots as a starting point rather than a verdict: both
    // answer "which prices matter and why", and neither has been ranked against
    // the other yet. Change the number, not the code that reads it.
    volume: 2,
    gaps: 1,
    rsi: 2,
};
/** Highest first; ties keep the order written above, which is stable. */
export const MODULES_BY_IMPORTANCE = Object.keys(MODULE_IMPORTANCE).sort((a, b) => MODULE_IMPORTANCE[b] - MODULE_IMPORTANCE[a]);
/** The share of a combined verdict this module is entitled to. */
export function moduleWeight(id) {
    const total = Object.values(MODULE_IMPORTANCE).reduce((a, b) => a + b, 0);
    return total > 0 ? MODULE_IMPORTANCE[id] / total : 0;
}
//# sourceMappingURL=module.js.map